import axios from "axios";
import ApiUrl from "../../constant/endpoint";
import {
  ADD_INTEREST_REQUEST,
  ADD_INTEREST_SUCCESS,
  ADD_INTEREST_FAILURE,
  UPDATE_INTEREST_REQUEST,
  UPDATE_INTEREST_SUCCESS,
  UPDATE_INTEREST_FAILURE,
  GET_INTEREST_REQUEST,
  GET_INTEREST_SUCCESS,
  GET_INTEREST_FAILURE,
  DELETE_INTEREST_REQUEST,
  DELETE_INTEREST_SUCCESS,
  DELETE_INTEREST_FAILURE,
} from "../constants/interestConstant";

export const addInterestAction = (interestData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_INTEREST_REQUEST });
    console.log(interestData);

    const url = ApiUrl.addInterest;
    const { data } = await axios.post(url, interestData);

    if (data.success) {
      dispatch({
        type: ADD_INTEREST_SUCCESS,
        payload: data,
      });
      return true;
    } else {
      dispatch({
        type: ADD_INTEREST_FAILURE,
        payload: data,
      });
      return false;
    }
  } catch (error) {
    console.error("Error:", error);

    dispatch({
      type: ADD_INTEREST_FAILURE,
      payload: error.response ? error.response.data : "Unknown error",
    });

    return false;
  }
};

export const deleteInterestAction = (interestId) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_INTEREST_REQUEST });
    const URL = `${ApiUrl.deleteInterest}?interestId=${interestId}`;

    const { data } = await axios.delete(URL);
    console.log("response", data);
    if (data.success) {
      dispatch({
        type: DELETE_INTEREST_SUCCESS,
        payload: data.success,
      });
      console.log("response", data);
      return true;
    }
    return false;
  } catch (error) {
    dispatch({
      type: DELETE_INTEREST_FAILURE,
      payload: error.response.data,
    });
  }
};

export const getInterestAction = (interestId) => async (dispatch) => {
  console.log("interestId", interestId);
  try {
    dispatch({ type: GET_INTEREST_REQUEST });
    const URL = `${ApiUrl.getInterestById}?interestId=${interestId}`;
    const { data } = await axios.get(URL);
    if (data.success) {
      dispatch({
        type: GET_INTEREST_SUCCESS,
        payload: data.response,
      });
      return data;
    }
  } catch (error) {
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    if (error.response.status === 500) {
      dispatch({
        type: GET_INTEREST_FAILURE,
        payload: "Internal Server Error",
      });
    } else {
      dispatch({
        type: GET_INTEREST_FAILURE,
        payload: error.response.data,
      });
    }
  }
};

export const updateInterestAction =
  (interestId, interestData) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_INTEREST_REQUEST });
      const URL = `${ApiUrl.updateInterest}?interestId=${interestId}`;
      const { data } = await axios.put(URL, interestData);
      if (data.success) {
        dispatch({
          type: UPDATE_INTEREST_SUCCESS,
          payload: data,
        });
        return true;
      }
    } catch (error) {
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      if (error.response.status === 500) {
        dispatch({
          type: UPDATE_INTEREST_FAILURE,
          payload: "Internal Server Error",
        });
      } else {
        dispatch({
          type: UPDATE_INTEREST_FAILURE,
          payload: error.response.data,
        });
      }
    }
  };
